import { ELanguage, EPages } from '@microfrontends/app-shell-v2'
import React, { ReactElement } from 'react'
import { AppStoreProvider } from '../../store'

import AccountSetting from '../../components/Page/AccountSetting'
import MainLayout from '../../components/Global/MainLayout'
export default function Page() {
    return <AccountSetting langCode={ELanguage.EN} />
}

Page.getLayout = function getLayout(page: ReactElement) {
    const { userIP } = page.props

    return (
        <AppStoreProvider langCode={ELanguage.EN}>
            <MainLayout pageName={EPages.ACCOUNT_SETTINGS} userIp={userIP} responsiveCornerColor='#f7f8fa'>
                {page}
            </MainLayout>
        </AppStoreProvider>
    )
}
